import MaterialTableCell, { TableCellProps } from '@mui/material/TableCell';

export function TableCell(props: TableCellProps) {
    return <MaterialTableCell data-testid={'TableCell-container'} {...props} />;
}

export default TableCell;
